import { render, staticRenderFns } from "./ReportElement.vue?vue&type=template&id=79f24284&scoped=true&"
import script from "./ReportElement.vue?vue&type=script&lang=js&"
export * from "./ReportElement.vue?vue&type=script&lang=js&"
import style0 from "./ReportElement.vue?vue&type=style&index=0&id=79f24284&scoped=true&lang=scss&"
import style1 from "./ReportElement.vue?vue&type=style&index=1&id=79f24284&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79f24284",
  null
  
)

export default component.exports